module.exports = __webpack_public_path__ + "static/media/Chu_Manh_Hai.5c866a7f.jpg";